import { Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { styles } from '../../styles';
import { useTranslation } from 'react-i18next';

interface MatchMakingProps {
  event: PublicEventDetailsResponse;
}

const MatchMaking = ({ event }: MatchMakingProps) => {
  const { t } = useTranslation();

  return (
    <View>
      <View
        style={{
          ...styles.rightSideBody,
          gap: 20,
          alignItems: 'flex-start',
        }}
      >
        <Text style={styles.bodyTitle}>{t('prospectus-title-8')}</Text>
        <Text style={styles.bodyTitle}>{t('prospectus-title-9')}</Text>
        <View style={styles.bodyLineBar} />
      </View>

      <View style={styles.increaseSalesWrapper}>
        <View style={styles.matchMakingColumn}>
          <View style={styles.matchMakingItem}>
            <Text style={styles.matchMakingTitle}>Fokus Partnering</Text>
            <Text style={styles.matchMakingBody}>
              Bei we.CONECT Events beinhaltet das Partnering, Sie mit den
              richtigen Entscheidern zusammen zu bringen – maßgeschneidert zu
              Ihren Lösungen und Bedürfnissen. Unsere Business Plattform hat für
              Sie das Ziel, Ihre Leadpipeline zu optimieren, Ihr Netzwerk zu
              erweitern und Projekte zu ermöglichen.
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default MatchMaking;
